import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/adminWork-actions';
import { AdminWorkActions } from '../constants';
import { IAdminWork } from 'src/types/adminWork';

export interface AdminWorkState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IAdminWork>;
    current: IAdminWork | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],

        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function adminWorks(state: AdminWorkState = initialState, action: Actions | any): AdminWorkState {
    switch (action.type) {
        case requestType(AdminWorkActions.PERSIST_ADMIN_WORK):
            return { ...state, error: '', inProgress: true };
        case successType(AdminWorkActions.PERSIST_ADMIN_WORK):
            return { ...state, current: action.payload, inProgress: false };
        case failureType(AdminWorkActions.PERSIST_ADMIN_WORK):
            return { ...state, error: action.error, inProgress: false };
        case requestType(AdminWorkActions.FETCH_ADMIN_WORKS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(AdminWorkActions.FETCH_ADMIN_WORKS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(AdminWorkActions.FETCH_ADMIN_WORKS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(AdminWorkActions.FETCH_ADMIN_WORK):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(AdminWorkActions.FETCH_ADMIN_WORK):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(AdminWorkActions.FETCH_ADMIN_WORK):
            return { ...state, inProgress: false, error: action.error };
        case requestType(AdminWorkActions.DELETE_ADMIN_WORK):
            return { ...state, error: '', inProgress: true };
        case successType(AdminWorkActions.DELETE_ADMIN_WORK):
            let idDel = action.payload.id;
            if (!idDel) {
                idDel = action.sagaPayload.id;
            }
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IAdminWork) => {
                        return user.id !== idDel;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(AdminWorkActions.DELETE_ADMIN_WORK):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
